// The filtering slice of the stem ViewModel: the system toggle (preferred / alternative)
// and the constructs narrowed by it, plus the suitable / recommended derivations.
import { computed, ref } from 'vue';
import { filterStemsBySystem, hasAlternativeSystem } from './stemSelectableItems';
import type { SelectableStem, StemSystemToggle } from '../stem.types';
import type { StemConstructs } from './stemConstructs';

/** The maximum number of recommended stems */
const MAX_RECOMMENDED_STEMS = 3;

export const useStemFiltering = (constructs: StemConstructs) => {
    const selectedStemSystem = ref<StemSystemToggle>(null);

    const filteredStemsBySystem = computed<SelectableStem[]>(() =>
        filterStemsBySystem(
            constructs.allStemConstructs.value,
            selectedStemSystem.value,
            constructs.preferredSystem.value,
        ),
    );
    const suitableStems = computed<SelectableStem[]>(() =>
        filteredStemsBySystem.value.filter((stem) => stem.suitable),
    );
    const recommendedStems = computed<SelectableStem[]>(() =>
        suitableStems.value.slice(0, MAX_RECOMMENDED_STEMS),
    );
    const hasRecommendedStems = computed<boolean>(() => recommendedStems.value.length > 0);
    const hasAlternativeStems = computed<boolean>(() =>
        hasAlternativeSystem(constructs.allStemConstructs.value, constructs.preferredSystem.value),
    );

    return {
        selectedStemSystem,
        filteredStemsBySystem,
        suitableStems,
        recommendedStems,
        hasRecommendedStems,
        hasAlternativeStems,
    };
};

export type StemFiltering = ReturnType<typeof useStemFiltering>;